<template>
  <div>
    <a-table
      :scroll="{ x: 1500, y: maxHeight }"
      :columns="cols"
      :locale="{
        filterConfirm: 'Tìm kiếm',
        filterReset: 'Huỷ',
        emptyText: 'Không có dữ liệu',
      }"
      :row-key="(record) => record.id"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :indentSize="8"
      @change="handleTableChange"
    >
      <template #link="{ text, record }">
        <a @click="() => openRecord(record)">{{ text }}</a>
      </template>
      <template #date="{ text }">{{
        text == null ? "" : moment(String(text)).format("DD-MM-YYYY")
      }}</template>
      <template #datetime="{ text }">{{
        text == null ? "" : moment(String(text)).format("DD-MM-YYYY HH:mm")
      }}</template>
      <template #time="{ text }">{{ text }}</template>
      <template #number="{ text }"
        ><strong>{{ formatNumber(text) }}</strong></template
      >
      <template #email="{ text }">
        <a :href="'mailto:' + text">
          <a-tooltip :title="text" placement="topLeft">
            {{ text }}
          </a-tooltip>
        </a>
      </template>
      <template #phone="{ text }">
        <a :href="'tel:' + text">{{ text }} </a>
      </template>
      <template #list="{ text, column }">
        <a-tooltip :title="renderList(text, column)" placement="topLeft">
          <a-tag :color="renderList(text, column, 'color')">
            {{ renderList(text, column) }}
          </a-tag>
        </a-tooltip>
      </template>
      <template #text="{ text }">
        <a-tooltip :title="text" placement="topLeft">
          {{ text }}
        </a-tooltip>
      </template>
      <template #file="{ text }">
        <img
          v-if="text"
          :src="text"
          alt="file"
          :style="{ width: '30px', height: '30px' }"
      /></template>
      <template
        #filterDate="{
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }"
      >
        <div style="padding: 8px">
          <a-date-picker
            :locale="locale"
            :value="selectedKeys[0]"
            @change="
              (e) => {
                setSelectedKeys(e ? [e] : []);
              }
            "
            type="date"
            format="DD-MM-YYYY"
            style="width: 100%"
          />
        </div>
        <div style="padding: 0 8px 8px">
          <a-button
            type="primary"
            size="small"
            style="width: 120px; margin-right: 8px"
            @click="
              () => handleSearchDate(selectedKeys, confirm, column.dataIndex)
            "
          >
            <template #icon><SearchOutlined /></template>
            Tìm kiếm
          </a-button>
          <a-button
            size="small"
            style="width: 120px"
            @click="
              () => handleReset(selectedKeys, clearFilters, column.dataIndex)
            "
          >
            Huỷ
          </a-button>
        </div>
      </template>
      <template
        #filterDropdown="{
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }"
      >
        <div style="padding: 8px">
          <a-input
            ref="searchInput"
            :placeholder="`Tìm kiếm`"
            :value="selectedKeys[0]"
            style="width: 250px; margin-bottom: 8px; display: block"
            @change="
              (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
            "
            @pressEnter="
              () => handleSearch(selectedKeys, confirm, column.dataIndex)
            "
          />
          <a-button
            type="primary"
            size="small"
            style="width: 120px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          >
            <template #icon><SearchOutlined /></template>
            Tìm kiếm
          </a-button>
          <a-button
            size="small"
            style="width: 120px"
            @click="
              () => handleReset(selectedKeys, clearFilters, column.dataIndex)
            "
          >
            Huỷ
          </a-button>
        </div>
      </template>
      <template #filterIcon="filtered">
        <search-outlined :style="{ color: filtered ? '#108ee9' : undefined }" />
      </template>
      <template #action="{ text, record }">
        <EditOutlined
          :style="{ color: '#3f51b5', marginRight: '8px' }"
          @click="() => showEdit(record)"
        />
        <DeleteOutlined
          :style="{ color: '#ee6e73', marginRight: '8px' }"
          @click="() => showConfirm(record)"
        />
      </template>
      <template #renderAction="{ text, record, index, column }">
        <a-tooltip placement="top">
          <template #title>
            <span>Sửa</span>
          </template>
          <EditOutlined
            :style="{ color: '#3f51b5', marginRight: '8px' }"
            @click="() => showEdit(record)"
            v-if="
              column.isEditByUser &&
              record.ins_id == userId &&
              record.count_order == 0 &&
              column.actions
                .find((p) => p.type === 'edit')
                .status.includes(record[column.statusField])
            "
          />
        </a-tooltip>
        <a-tooltip placement="top">
          <template #title>
            <span>Sao chép</span>
          </template>
          <CopyOutlined
            :style="{ color: '#66bb6a', marginRight: '8px' }"
            @click="() => showCopy(record)"
            v-if="
              column.isEditByUser &&
              column.actions
                .find((p) => p.type === 'copy')
                .status.includes(record[column.statusField])
            "
          />
        </a-tooltip>

        <a-tooltip placement="top">
          <template #title>
            <span>Xóa</span>
          </template>
          <DeleteOutlined
            :style="{ color: '#ee6e73', marginRight: '8px' }"
            @click="() => showConfirm(record)"
            v-if="
              column.isEditByUser &&
              record.ins_id == userId &&
              column.actions
                .find((p) => p.type === 'delete')
                .status.includes(record[column.statusField])
            "
          />
        </a-tooltip>
      </template>
      <template #customRender="{ text, record, index, column }">
        <span v-if="searchText && searchedColumn === column.dataIndex">
          <template
            v-for="(fragment, i) in text
              .toString()
              .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
          >
            <mark
              v-if="fragment.toLowerCase() === searchText.toLowerCase()"
              :key="i"
              class="highlight"
              >{{ fragment }}</mark
            >
            <template v-else>{{ fragment }}</template>
          </template>
        </span>
        <template v-else>
          {{ text }}
        </template>
      </template>
    </a-table>
    <div class="pagination" v-if="data.length > 0">
      <a-pagination
        show-size-changer
        v-model="pagination.current"
        :showLessItems="pagination.showLessItems"
        :showTitle="pagination.showTitle"
        :size="pagination.size"
        :hideOnSinglePage="pagination.hideOnSinglePage"
        :page-size-options="pagination.pageSizeOptions"
        :total="pagination.total"
        :showTotal="
          (total, range) => `${range[0]}-${range[1]} / ${total} bản ghi `
        "
        :page-size="pagination.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="onShowSizeChange"
      >
        <template #buildOptionText="props">
          <span>{{ props.value }} / trang</span>
        </template>
      </a-pagination>
    </div>
  </div>
</template>
<script >
import { defineComponent } from "vue";
import axios from "axios";
import mixins from "@/mixins";
import moment from "moment/moment";
import locale from "ant-design-vue/es/date-picker/locale/vi_VN";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  CopyOutlined,
  StopOutlined,
  FileImageOutlined,
  SwapOutlined,
  UserSwitchOutlined,
  EnterOutlined,
} from "@ant-design/icons-vue";

export default defineComponent({
  mixins: [mixins],
  components: {
    SearchOutlined,
    EditOutlined,
    DeleteOutlined,
    CopyOutlined,
    StopOutlined,
    FileImageOutlined,
    SwapOutlined,
    UserSwitchOutlined,
    EnterOutlined,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    entity: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default: [],
    },
    isAction: {
      type: Boolean,
      default: true,
    },
    isPopup: {
      type: Boolean,
      default: true,
    },
    isAutoLoad: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    "emitRecord",
    "showAdvance",
    "openRecord",
    "editRecord",
    "duplicateRecord",
    "cancelRecord",
    "rightClick",
  ],
  data() {
    let maxHeight = window.innerHeight - 280;
    let cols = [];

    if (this.isAction) {
      cols.push({
        title: "Hành động",
        key: "operation",
        fixed: "left",
        width: 110,
        slots: { customRender: "action" },
      });
    }
    var tmp = this.columns.map((p) => {
      switch (p.dataType) {
        case "number":
          p.className = "column-number";
          break;
        case "date":
        case "time":
        case "datetime":
          p.className = "column-date";
          break;
        default:
          p.className = "column-string";
          break;
      }
      if (p.isBold) {
        p.class += " text-bold";
      }
      if (!p.slots) {
        p.slots = {
          filterIcon: "filterIcon",
          customRender: "customRender",
        };
        if (p.dataSource) {
          if (p.disableSearch) {
            p.liststatus = p.dataSource;
          }
          p.filter = p.dataSource;
          // p.filterMultiple= false;
        } else {
          if (p.dataType == "date" || p.dataType == "datetime") {
            p.slots.filterDropdown = "filterDate";
            if (p.disableSearch) {
              p.slots.filterDropdown = "";
            }
          } else if (p.dataType == "file") {
            p.slots.filterDropdown = "";
          } else {
            p.slots.filterDropdown = "filterDropdown";
          }
        }
        if (p.isCodeIndex) {
          p.slots.customRender = "link";
        } else {
          if (p.dataType) {
            p.slots.customRender = p.dataType;
          }
        }
      }

      if (p.dataSource) {
      } else {
        p.onFilter = (value, record) => {
          return true;
        };

        p.onFilterDropdownVisibleChange = (visible) => {
          if (visible) {
            setTimeout(() => {
              if (this.searchInput) {
                this.searchInput.focus();
              }
            }, 0);
          }
        };
      }
      return p;
    });
    cols = [].concat.apply(cols, tmp);
    return {
      locale,
      maxHeight,
      moment,
      fromDate: moment().startOf("month").format("YYYY/MM/DD"),
      toDate: moment().endOf("month").format("YYYY/MM/DD"),
      data: [],
      pagination: {
        showLessItems: true,
        size: "small",
        showTitle: false,
        hideOnSinglePage: false,
        showSizeChanger: true,
        pageSize: 50,
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} / ${total} bản ghi`,
      },
      loading: false,
      cols: cols,
      selectedRowKeys: [],
      filters: [],
      searchText: "",
      isFiltering: false,
      userId: this.$auth.user().id,
      recordContext: {},
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  mounted() {
    this.pagination.current = 1;
    if (this.isAutoLoad) {
      this.fetch({
        subFilters: [],
        filters: [],
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    }
  },
  created() {
    this.eventBus.on("changeRangeDate", (data) => this.handleDate(data));
  },
  destroyed() {
    this.eventBus.off("onChangeRangeDate");
  },
  methods: {
    handleDate(data) {
      this.fromDate = data.fromDate;
      this.toDate = data.toDate;
      this.pagination.current = 1;
      this.fetch({
        subFilters: [],
        filters: [],
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
      this.handleTableChange({ current, pageSize }, [], []);
    },
    actionRecord(record, action) {
      if (action.type == "edit") {
        this.showEdit(record);
      } else if (action.type == "delete") {
        this.showConfirm(record);
      } else {
        this.$emit("emitRecord", {
          action: action.type,
          record: record,
        });
      }
    },
    renderList(text, column, key = "text") {
      let item = column.liststatus.find((p) => p.value == text);
      return item ? item[key] : (key = "color" ? "blue" : "");
    },
    handleTableChange(pagination, filters, sorter) {
      if (this.isFiltering) return;

      for (let prop in filters) {
        // case lọc theo trạng thái
        this.filters = this.filters.filter((p) => p.field != prop);
        if (filters[prop]) {
          if (Array.isArray(filters[prop])) {
            if (filters[prop].length > 0) {
              this.filters.push({
                field: prop,
                operator: "in",
                value: filters[prop],
              });
            }
          } else {
            this.filters.push({
              field: prop,
              operator: "like",
              value: filters[prop],
            });
          }
        }
      }
      const pager = Object.assign({}, this.pagination);
      pager.current =
        typeof pagination.current !== "undefined"
          ? pagination.current
          : this.pagination.current;
      pager.pageSize =
        typeof pagination.pageSize !== "undefined"
          ? pagination.pageSize
          : this.pagination.pageSize;

      this.pagination = pager;

      this.fetch({
        sortField: sorter.field,
        sortOrder: sorter.order,
        subFilters: this.subFilters,
        filters: this.filters,
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    },
    fetch(params = {}) {
      setTimeout(() => {
        this.loading = true;
      }, 0);
      const pa = JSON.parse(JSON.stringify(params));
      pa.pageSize = this.pagination.pageSize;
      pa.pageIndex = this.pagination.current;

      pa.filters = pa.filters.map((p) => {
        let field = this.columns.find((x) => x.dataIndex === p.field);
        if (field) {
          p.field = field.originalIndex || field.dataIndex;
        }
        return p;
      });
      if (pa.subFilters) {
        pa.subFilters = pa.subFilters.map((p) => {
          let field = this.columns.find((x) => x.dataIndex === p.field);
          if (field) {
            p.field = field.originalIndex || field.dataIndex;
          }
          return p;
        });
      }
      axios
        .post(`c-${this.entity}/list`, pa)
        .then((response) => {
          const pagination = Object.assign({}, this.pagination);
          this.loading = false;
          if(response.data && response.data.data){
          pagination.total = response.data.data.totalCount;
          this.data = response.data.data.items;
          this.pagination = pagination;
          this.isFiltering = false;

          this.maxHeight =
            this.data.length == 0
              ? 1
              : this.maxHeight == 1
              ? window.innerHeight - 280
              : this.maxHeight;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
    reload(filter) {
      if (filter) {
        let tmp_filter = this.filters.find((p) => p.field == filter.field);
        if (!tmp_filter) {
          this.filters.push(filter);
        } else {
          tmp_filter.value = filter.value;
        }
      }
      this.pagination.current = 1;
      this.fetch({
        filters: this.filters,
        subFilters: this.subFilters,
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
      setTimeout(() => {
        this.selectedRowKeys = [];
        this.$emit("showAdvance", this.selectedRowKeys);
      }, 0);
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
      this.isFiltering = true;
      this.filters = this.filters.filter((p) => p.field != dataIndex);

      this.filters.push({
        field: dataIndex,
        value: selectedKeys[0],
      });
      this.reload();
    },
    handleSearchDate(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0].format("DD-MM-YYYY");
      this.searchedColumn = dataIndex;
      this.isFiltering = true;
      this.filters = this.filters.filter((p) => p.field != dataIndex);

      this.filters.push({
        field: dataIndex,
        operator: "equal",
        value: selectedKeys[0].format("YYYY-MM-DD"),
      });
      this.reload();
    },
    handleReset(selectedKeys, clearFilters, dataIndex) {
      clearFilters();
      this.searchText = "";
      this.filters = this.filters.filter((p) => p.field != dataIndex);
      this.reload();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.$emit("showAdvance", selectedRowKeys);
    },
    openRecord(record) {
      this.$emit("openRecord", record);
    },
    handleRightClick(e, record) {
      e.preventDefault();
      this.$refs.menu.open(e);
      this.recordContext = record;
    },

    showEdit(record) {
      this.$emit("editRecord", record);
    },
    showCopy(record) {
      this.$emit("duplicateRecord", record);
    },
    showCancel(record) {
      this.$emit("cancelRecord", record);
    },
    showConfirm(record) {
      let name = record[this.cols.find((p) => p.isNameIndex).dataIndex];
      let entity = this.entity;
      let component = this;
      this.$confirm({
        title: "Bạn chắc chắn muốn xoá bản ghi " + name + "?",
        content: "",
        okText: "Xác nhận",
        cancelText: "Huỷ",
        onOk() {
          axios
            .delete(`c-${entity}?id=${record.id}`)
            .then((response) => {
              if (response.data.errorCode == 0) {
                component.$message.success(`Xoá ${component.title} thành công`);
                component.reload();
              } else {
                component.$message.error(response.data.errorMessage);
              }
            })
            .catch((error) => {
              component.$message.error(error.message);
            });
        },
        onCancel() {},
      });
    },
  },
});
</script>
<style lang="scss" scoped>
:deep() {
  th.column-string,
  td.column-string {
    text-align: left !important;
  }
  th.column-date,
  td.column-date {
    text-align: center !important;
  }

  th.column-number,
  td.column-number {
    text-align: right !important;
  }
}

.text-bold {
  font-weight: 700 !important;
}

.pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 12px;
  margin-left: 8px;
}
:deep() .ant-table-thead > tr > th,
:deep() .ant-table-tbody > tr > td {
  padding: 10px !important;
}
:deep() thead.ant-table-thead > tr {
  height: unset !important;
}
:deep() .ant-table-body {
  height: calc(100vh) !important;
}
:deep() .ant-table-body .ant-table-placeholder {
  display: none;
}
.list-option {
  margin: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  border-radius: 4px;
  width: 200px;
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    .sub-option {
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
    }
    &:hover {
      background: #fafafa;
    }
  }
}
li.option-item.border-bottom {
  border-bottom: 1px solid #b3b3b3;
}
</style>